import { render, staticRenderFns } from "./PQBox.vue?vue&type=template&id=7671fe98&scoped=true&"
import script from "./PQBox.vue?vue&type=script&lang=js&"
export * from "./PQBox.vue?vue&type=script&lang=js&"
import style0 from "./PQBox.vue?vue&type=style&index=0&id=7671fe98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671fe98",
  null
  
)

export default component.exports